import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { PageBreadcrumbProps, PageLayout } from "../../"
import { generateHostBreadcrumbs, HostIndexTopbar } from "./";
import { usePageTitle, PageTitleProvider } from "../../../hooks";
import { BreadcrumbProps } from "../../../components";

function BaseLayout() {

  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState<PageBreadcrumbProps>();
  const { title } = usePageTitle();

  /**
   * Initialize breadcrumbs for the page depending on the route
   */
  useEffect(() => {
    const newBreadcrumbs:BreadcrumbProps = generateHostBreadcrumbs(location.pathname);
    setBreadcrumbs(newBreadcrumbs);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  return (
    <PageLayout topbar={<HostIndexTopbar />} title={title} breadcrumbs={breadcrumbs}>
      <Outlet />
    </PageLayout >
  )
}

export function HostIndexLayout() {
  // Wrap the BaseUserLayout in a PageTitleProvider.
  // This prevents an error of the context not being initialized when the usePageTitle hook is called.
  return (
    <PageTitleProvider>
      <BaseLayout />
    </PageTitleProvider>
  );
}

export default HostIndexLayout
